<template>
    <div class="dashboard-container">
        <!-- 显示外部链接内容 -->
        <IframeViewer 
            v-if="showIframe" 
            :url="currentUrl" 
            :title="currentTitle"
            @back="handleBack"
        />
        
        <!-- BIM星球主页面内容 -->
        <template v-else>
            <div v-show="ifCollapsed" class="bim-planet-title">BIM星球</div>
            <header class="header">
                
                <div class="search-section">
                    <div class="search-bar">
                        <input 
                            type="text" 
                            v-model="searchKeyword" 
                            placeholder="搜索AI助理" 
                            @keyup.enter="handleSearch"
                        />
                        <button @click="handleSearch">搜索</button>
                    </div>
                    <div class="hot-keywords">
                        热词: 
                        <a href="#" @click.prevent="searchByKeyword('建模')">建模</a> 
                        <a href="#" @click.prevent="searchByKeyword('渲染')">渲染</a> 
                        <a href="#" @click.prevent="searchByKeyword('投标')">投标</a>
                        <a href="#" @click.prevent="clearSearch" v-if="searchKeyword" class="clear-search">清除</a>
                    </div>
                </div>
                <section class="banner">
                    <div class="banner-text">
                        <p>建模、投标、追踪行业动态、渲染出图、辅助审查</p>
                        <h1>你的专属AI智能助理</h1>
                    </div>
                    <img src="../../assets/images/bim-planet/机器人图片.png" alt="AI Robot" class="banner-image" />
                </section>
            </header>
            <main class="main-content">
                <h2 class="section-title">AI智能助理</h2>
                <div class="card-grid">
                    <div v-for="(card, index) in filteredAssistants" :key="index" class="card">
                        <img :src="card.icon" :alt="card.title" class="card-icon" />
                        <div class="card-body">
                            <h3 class="card-title">{{ card.title }}</h3>
                            <p class="card-description">{{ card.description }}</p>
                        </div>
                        <button @click="openInIframe(card)" class="card-link">👉</button>
                    </div>
                </div>
                <!-- 无搜索结果提示 -->
                <div v-if="searchKeyword && filteredAssistants.length === 0" class="no-results">
                    <p>🔍 未找到与 "{{ searchKeyword }}" 相关的AI助理</p>
                    <a href="#" @click.prevent="clearSearch">清除搜索</a>
                </div>
            </main>
        </template>
    </div>
</template>
  
<script>
import IframeViewer from '../components/IframeViewer.vue';

export default {

    name: 'DashboardComponent',
    components: {
        IframeViewer
    },
    data() {
        return {
            
            searchKeyword: '',
            showIframe: false,
            currentUrl: '',
            currentTitle: '',
            aiAssistants: [
                 {
                    icon: require('../../assets/images/bim-planet/AI找图.png'),
                    title: 'BIM智能渲染',
                    description: '上传BIM截图，实现快速AI渲染...',
                    link: 'http://szlsxiaowu.cn:5000/',
                    canEmbed: false  // 自己的网站可以嵌入
                },
                {
                    icon: require('../../assets/images/bim-planet/BIM建模助手图标.png'),
                    title: 'BIM建模助手',
                    description: '大幅提升模型创建效率和准确性，支持...',
                    link: 'https://www.coze.cn/store/agent/7499378074506117155?bot_id=true',
                    canEmbed: false  // coze.cn 不允许iframe嵌入
                },
                {
                    icon: require('../../assets/images/bim-planet/BIM政策分析.png'),
                    title: 'BIM政策热点',
                    description: '关于BIM及建筑数字化的政策、热点、新闻都可以问我~...',
                    link: 'https://www.coze.cn/store/agent/7500016052349403155?bot_id=true',
                    canEmbed: false
                },
                {
                    icon: require('../../assets/images/bim-planet/AI标书.png'),
                    title: 'BIM投标助手',
                    description: '基于模型快速算量、智能清单组价、技术标...',
                    link: 'https://www.coze.cn/store/agent/7503545670893404179?bot_id=true',
                    canEmbed: false
                },
                // {
                //     icon: require('../../assets/images/bim-planet/BIM审核图片.jpg'),
                //     title: 'BIM审查',
                //     description: '智能辅助图纸审查，规避错漏碰缺，提升...',
                //     link: 'https://example.com/bim-review',
                //     canEmbed: true
                // },
                {
                    icon: require('../../assets/images/bim-planet/AI专家.png'),
                    title: 'BIM解决方案',
                    description: '基于海量数据及专家经验，智能匹配项目需求...',
                    link: 'https://www.coze.cn/store/agent/7499405400996085801?bot_id=true',
                    canEmbed: false
                },
               
                {
                    icon: require('../../assets/images/bim-planet/BIM智多星.png'),
                    title: '智多星BIM专家',
                    description: '多智能体协作，集成BIM建模、BIM投标、BIM渲染等功能...',
                    link: 'https://www.coze.cn/store/agent/7499408481909653544?bot_id=true',
                    canEmbed: false
                }
            ]
        };
    },
    computed: {
        ifCollapsed() {
            return this.$store.state.isChatListCollapsed;
        },
        filteredAssistants() {
            if (!this.searchKeyword.trim()) {
                return this.aiAssistants;
            }
            const keyword = this.searchKeyword.toLowerCase().trim();
            return this.aiAssistants.filter(card => 
                card.title.toLowerCase().includes(keyword) || 
                card.description.toLowerCase().includes(keyword)
            );
        }
    },
    methods: {
        openInIframe(card) {
            // 检查是否可以嵌入iframe
            if (card.canEmbed === false) {
                // 不支持嵌入的网站，在新标签页打开
                window.open(card.link, '_blank');
            } else {
                // 支持嵌入的网站，在当前页面加载
                this.currentUrl = card.link;
                this.currentTitle = card.title;
                this.showIframe = true;
            }
        },
        handleBack() {
            this.showIframe = false;
            this.currentUrl = '';
            this.currentTitle = '';
        },
        handleSearch() {
            // 搜索逻辑已通过computed属性自动处理
            // 如果没有搜索结果，可以给用户提示
            if (this.searchKeyword && this.filteredAssistants.length === 0) {
                this.$message ? this.$message.warning('未找到匹配的AI助理') : alert('未找到匹配的AI助理');
            }
        },
        searchByKeyword(keyword) {
            this.searchKeyword = keyword;
        },
        clearSearch() {
            this.searchKeyword = '';
        }
    }
}
</script>
  
<style scoped>
/* Scoped styles ensure they only apply to this component */
.dashboard-container {
    flex: 3;
    display: flex;
    margin-top: 80px;
    flex-direction: column;
    background: white;
    border-radius: 20px;
    height: calc(100vh - 80px);
    overflow: hidden;
}

/* Header Styles */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-top: 1px solid #e0e0e0;
}

.bim-planet-title {
    display: flex;
    position:absolute;
    font-size: 24px;
    margin-left: 30px;
    margin-top:-50px;
    font-weight: bold;
    color: #0056b3;
}

.search-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* Align items to the start for the keywords */
}

.search-bar {
    display: flex;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    /* Ensures button fits nicely */
}

.search-bar input {
    padding: 8px 12px;
    border: none;
    outline: none;
    font-size: 14px;
    min-width: 250px;
    /* Adjust width as needed */
}

.search-bar button {
    padding: 8px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s ease;
}

.search-bar button:hover {
    background-color: #0056b3;
}

.hot-keywords {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
}

.hot-keywords a {
    color: #007bff;
    text-decoration: none;
    margin-left: 8px;
    cursor: pointer;
    transition: color 0.2s ease;
}

.hot-keywords a:hover {
    text-decoration: underline;
    color: #0056b3;
}

.hot-keywords .clear-search {
    color: #ff6b6b;
    margin-left: 15px;
}

.hot-keywords .clear-search:hover {
    color: #ee5253;
}

/* 无搜索结果提示 */
.no-results {
    text-align: center;
    color: #666;
    padding: 40px;
    font-size: 16px;
}


.user-info {
    display: flex;
    align-items: center;
}

.user-phone {
    margin-right: 15px;
    font-size: 14px;
    color: #555;
}

.user-avatar {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 1px solid #ddd;
}

/* Banner Styles */
.banner {
    display: flex;
    justify-content: space-between;
    /* Pushes text left, image right */
    align-items: center;
    background: linear-gradient(to right, #003366, #005ea2);
    /* Example blue gradient */
    color: white;
    padding: 0px 60px;
    margin: 20px 40px;
    /* Add some margin around the banner */
    border-radius: 8px;
}

.banner-text p {
    font-size: 16px;
    margin-bottom: 5px;
    opacity: 0.9;
}

.banner-text h1 {
    font-size: 32px;
    font-weight: bold;
    margin: 0;
}

.banner-image {
    max-height: 120px;
    /* Adjust size as needed */
    width: auto;
}

/* Main Content Styles */
.main-content {
    padding: 0 40px 40px 40px;
    flex: 1;
    overflow-y: auto;
}

.section-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #333;
    padding-left: 10px;
    /* Consistent with card alignment */
}

.card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    /* Responsive grid */
    gap: 25px;
    padding-bottom: 20px;
}

.card {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: flex-start;
    /* Align icon top */
    transition: box-shadow 0.3s ease, transform 0.3s ease;
    position: relative;
    /* For absolute positioning of link */
}

.card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    transform: translateY(-3px);
}

.card-icon {
    width: 70px;
    /* Adjust icon size */
    height: 70px;
    margin-right: 15px;
    flex-shrink: 0;
    border-radius: 35px;
    /* Prevent icon from shrinking */
}

.card-body {
    flex-grow: 1;
}

.card-title {
    font-size: 16px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 8px;
    color: #333;
}

.card-description {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    margin: 0;
}

.card-link {
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 20px;
    background-color: white;
    border: none;
    transition: color 0.2s;
    cursor: pointer;
}

.card:hover .card-link {
    font-size: 22px;
}


/* Basic Responsiveness (Example) */
@media (max-width: 768px) {
    .header {
        flex-direction: column;
        align-items: flex-start;
        padding: 15px 20px;
    }

    .search-section {
        margin: 10px 0;
        width: 100%;
        /* Make search take full width */
    }

    .search-bar input {
        min-width: auto;
        /* Allow input to shrink */
        flex-grow: 1;
        /* Allow input to grow */
    }

    .user-info {
        margin-top: 10px;
        align-self: flex-end;
    }

    .banner {
        display: none;
    }

    .banner-image {
        max-height: 100px;
        margin-top: 20px;
    }

    .main-content {
        padding: 20px;
    }

    .card-grid {
        grid-template-columns: 1fr;
        /* Stack cards on smaller screens */
    }
}
</style>